module.exports = __webpack_public_path__ + "img/62.d195b80f.jpg";